import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMessagesSelectedNavIconSecondary from './svgs/MessagesSelectedNavIconSecondary.js';
import SvgMessagesSelectedNavIcon from './svgs/MessagesSelectedNavIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var messagesSelectedNavIcon = (props => useIcon(SvgMessagesSelectedNavIcon, SvgMessagesSelectedNavIconSecondary, props));

export { messagesSelectedNavIcon as default };
